export const cities = [
  // Tier 1 — Local area
  {
    slug: "alencon",
    name: "Alençon",
    region: "Normandie",
    department: "Orne",
    intro: "Vous êtes une entreprise ou un indépendant à Alençon et vous cherchez un partenaire web de confiance ? Lacrea accompagne les professionnels alençonnais dans la création de sites internet modernes et performants.",
    why: "Proche d'Alençon, nous comprenons les enjeux des entreprises locales de l'Orne. Que vous soyez artisan, commerçant ou PME, nous créons des sites qui reflètent votre savoir-faire et attirent de nouveaux clients dans la région.",
    keywords: "création site internet Alençon, agence web Alençon, site web Orne, développeur web Alençon",
  },
  {
    slug: "le-mans",
    name: "Le Mans",
    region: "Pays de la Loire",
    department: "Sarthe",
    intro: "Entrepreneurs et PME du Mans, boostez votre visibilité en ligne avec un site web professionnel. Lacrea conçoit des sites sur mesure pour les entreprises mancelles.",
    why: "Le Mans est un bassin économique dynamique. Nous aidons les entreprises sarthoises à se démarquer en ligne avec des sites rapides, élégants et optimisés pour le référencement local.",
    keywords: "création site internet Le Mans, agence web Le Mans, site web Sarthe, développeur web Le Mans",
  },
  {
    slug: "laval",
    name: "Laval",
    region: "Pays de la Loire",
    department: "Mayenne",
    intro: "Lacrea accompagne les entreprises de Laval et de la Mayenne dans leur transformation digitale. Un site web professionnel est la première étape pour développer votre activité.",
    why: "La Mayenne regorge de PME et d'artisans talentueux. Nous leur donnons une présence en ligne à la hauteur de leur expertise, avec des sites modernes et des tarifs accessibles.",
    keywords: "création site internet Laval, agence web Laval, site web Mayenne, développeur web Laval",
  },
  {
    slug: "chartres",
    name: "Chartres",
    region: "Centre-Val de Loire",
    department: "Eure-et-Loir",
    intro: "Vous êtes basé à Chartres ou en Eure-et-Loir ? Lacrea crée des sites internet performants pour les entreprises chartraines qui veulent se développer en ligne.",
    why: "Entre Paris et la province, Chartres bénéficie d'un tissu économique riche. Nous aidons les entreprises locales à capter une clientèle plus large grâce à un site web optimisé.",
    keywords: "création site internet Chartres, agence web Chartres, site web Eure-et-Loir, développeur web Chartres",
  },
  {
    slug: "dreux",
    name: "Dreux",
    region: "Centre-Val de Loire",
    department: "Eure-et-Loir",
    intro: "Lacrea aide les professionnels de Dreux et ses environs à se lancer ou se renforcer sur le web. Sites vitrines, e-commerce ou applications — nous avons la solution.",
    why: "Dreux et son agglomération comptent de nombreuses entreprises qui méritent une vitrine digitale à la hauteur. Nous proposons des sites clés en main, livrés rapidement.",
    keywords: "création site internet Dreux, agence web Dreux, site web Dreux, développeur web Dreux",
  },
  // Tier 2 — Nearby big cities
  {
    slug: "rennes",
    name: "Rennes",
    region: "Bretagne",
    department: "Ille-et-Vilaine",
    intro: "Capitale de la Bretagne et pôle numérique majeur, Rennes est un terreau fertile pour les entreprises innovantes. Lacrea accompagne les professionnels rennais avec des sites web de qualité.",
    why: "Rennes est une ville tech par excellence. Nous partageons cette culture de l'innovation et proposons des sites construits avec les technologies les plus modernes, à des tarifs compétitifs.",
    keywords: "création site internet Rennes, agence web Rennes, site web Bretagne, développeur web Rennes",
  },
  {
    slug: "caen",
    name: "Caen",
    region: "Normandie",
    department: "Calvados",
    intro: "Entreprises caennaises, passez au digital avec un site web professionnel. Lacrea conçoit des sites sur mesure pour les PME et indépendants du Calvados.",
    why: "Caen et la Normandie abritent un écosystème entrepreneurial en pleine croissance. Nous aidons les entreprises locales à rayonner en ligne avec des sites performants et bien référencés.",
    keywords: "création site internet Caen, agence web Caen, site web Calvados, développeur web Caen",
  },
  {
    slug: "tours",
    name: "Tours",
    region: "Centre-Val de Loire",
    department: "Indre-et-Loire",
    intro: "Lacrea accompagne les entreprises de Tours et de la Touraine dans la création de leur site internet. Design moderne, performance et SEO pour booster votre activité.",
    why: "Tours est une ville attractive avec un tissu économique diversifié. Nous aidons les professionnels tourangeaux à convertir leur présence digitale en résultats concrets.",
    keywords: "création site internet Tours, agence web Tours, site web Indre-et-Loire, développeur web Tours",
  },
  {
    slug: "rouen",
    name: "Rouen",
    region: "Normandie",
    department: "Seine-Maritime",
    intro: "Entreprises rouennaises, confiez la création de votre site web à Lacrea. Nous concevons des sites modernes et performants pour les professionnels de Seine-Maritime.",
    why: "Rouen et sa métropole sont un pôle économique important de Normandie. Nous accompagnons les entreprises locales avec des solutions web adaptées à leurs ambitions.",
    keywords: "création site internet Rouen, agence web Rouen, site web Seine-Maritime, développeur web Rouen",
  },
  // Tier 3 — Paris
  {
    slug: "paris",
    name: "Paris",
    region: "Île-de-France",
    department: "Paris",
    intro: "Lacrea offre aux entreprises parisiennes un service de création web haut de gamme à des tarifs accessibles. Qualité d'agence, réactivité de freelance.",
    why: "À Paris, la concurrence est forte et votre site web est votre première impression. Nous créons des sites qui se démarquent — design soigné, chargement rapide et référencement optimisé.",
    keywords: "création site internet Paris, agence web Paris, site web Paris, développeur web Paris, freelance web Paris",
  },
];
